// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1CJMk_pQLK1fExM79pFr-y","positionRight":"_1MlFVz9FHHPTwkocQnrZuJ"};